import { render, staticRenderFns } from "./applet.vue?vue&type=template&id=03b3fbe5&scoped=true&"
import script from "./applet.vue?vue&type=script&lang=js&"
export * from "./applet.vue?vue&type=script&lang=js&"
import style0 from "./applet.vue?vue&type=style&index=0&id=03b3fbe5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b3fbe5",
  null
  
)

export default component.exports